export default __webpack_public_path__ + "static/media/image 7.18b4c2da.svg";